import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './index.css';
import { router } from './router.tsx';
import { AuthProvider, AuthGate } from './auth';
import { theme } from './theme';
// import { worker } from './mocks/browser.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: 'always',
    },
  },
});

const enableMocking = async () => {
  return Promise.resolve();
  // local dev only
  // return worker.start();
};

const root = document.getElementById('root') as HTMLElement;

enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <AuthGate>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </AuthGate>
        </AuthProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
